import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params) => {
    return network.post('api/bo/management/updateContract', params).then((response) => {
        return response.data;
    });
};
export const useMutationRenameSubProgram = () => {
    return useMutation<any, QueryError, IRenameSubProgram>({ mutationFn: (params) => mutationFn(params) });
};

interface IRenameSubProgram {
    contractId: number;
    contractName: string;
}
